<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		/>

		<section class="main-content cookie-content">
			<div v-if="cookies.size > 0" :key="locale" class="row">
				<div class="columns column6">
					<p><!-- empty --></p>
				</div>
				<div class="columns column6">
					<div href="#" class="button" @click="openConsent">{{ $t('consentOpen') }}</div>
					<h2>Cookies</h2>
					<div
						v-for="category in ['Necessary', 'Performance', 'Functional', 'Advertising', 'Unclassified']"
						:key="category"
					>
						<div v-if="cookies.has(category.toLowerCase())">
							<h3>{{ $t(`consentCategory${category}`) }}</h3>
							<div v-if="category !== 'unclassified'">
								<div v-html="defaults[locale].cookieConsent[`content${category}`]" />
							</div>
							<div class="responsive-table">
								<table class="cookie-table">
									<colgroup>
										<col style="width: 20%" />
										<col style="width: 15%" />
										<col style="width: 55%" />
										<col style="width: 10%" />
									</colgroup>
									<thead>
										<tr>
											<th>{{ $t('consentCookieName') }}</th>
											<th>{{ $t('consentCookieProvider') }}</th>
											<th>{{ $t('consentCookiePurpose') }}</th>
											<th>{{ $t('consentCookieExpiry') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="cookie in cookies.get(category.toLowerCase())" :key="cookie.name">
											<td>{{ cookie.name }}</td>
											<td>
												<a v-if="cookie.q2" target="_blank" :href="cookie.q2">
													{{ cookie.q1 }}</a
												>
												<span v-else>{{ cookie.q1 }}</span>
											</td>
											<td>{{ cookie.desc }}</td>
											<td>{{ cookie.expiration_time }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:items="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const { openConsent, cfInit, cfDestroy } = useCookieConsent();

await fetchPage();
await fetchDefaults();

const cookies = ref(new Map());

onMounted(() => {
	cfInit(initCookieFirst);
});

onBeforeUnmount(() => {
	cfDestroy();
});

const initCookieFirst = () => {
	window.CookieFirst.fetchLatestScan()
		.then((result) => {
			cookies.value = getCookiesByCategory(result.cookies);
		})
		.catch((error) => {
			// eslint-disable-next-line no-console
			console.error(error);
		});
};

const getCookiesByCategory = (cookies) => {
	const cookiesByCategory = new Map();

	cookies.forEach(function (cookie) {
		if (!cookiesByCategory.has(cookie.cat)) {
			cookiesByCategory.set(cookie.cat, []);
		}
		cookiesByCategory.get(cookie.cat).push(cookie);
	});

	return cookiesByCategory;
};
</script>

<style lang="scss" scoped>
#intro.main-content {
	padding-bottom: 25px;
}

.main-content.cookie-content {
	padding-top: 0;

	h2 {
		font-size: 2.2em;
	}

	.button {
		margin: 0 0 50px;
	}
}

h3 {
	margin: 25px 0;
	font-size: 1.7em;
}

table {
	width: 100%;
	min-width: 800px;
	text-align: left;

	th,
	td {
		padding: 10px;
		border-bottom: 1px solid #ccc;
	}
}

.subpage .main-content .row {
	max-width: 1220px;
}

.responsive-table {
	width: 100%;
	overflow-x: auto;
	scrollbar-width: thin;
}
</style>
